import { Component } from '@angular/core';
import type { ILoadingCellRendererParams } from 'ag-grid-community';
import { SvgIconComponent } from 'shared/components/atoms';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-data-table-loading-renderer',
    templateUrl: './data-table-loading-renderer.component.html',
    styles: ``,
    imports: [SvgIconComponent]
})
export class DataTableLoadingRendererComponent implements ILoadingOverlayAngularComp {
  public params!: ILoadingCellRendererParams;

  public agInit(params: ILoadingCellRendererParams): void {
    this.params = params;
  }
}
